export default {
  // Generic
  ADD: 'Add',
  EDIT: 'Edit',
  PERMISSIONS: 'Permissions',
  DELETE: 'Delete',
  REMOVE: 'Remove',
  DUPLICATE: 'Duplicate',
  EDIT_DETAILS: 'Edit',
  ARCHIVE: 'Archive',
  VIEW_INSPECTIONS: 'View Inspections',
  VIEW_FUEL_ENTRIES: 'View Fuel Entries',
  VIEW_DEF_ENTRIES: 'View AdBlue Entries',
  VIEW_HISTORY: 'View History',
  ALL: 'All',
  DOWNLOAD: 'Download',
  CANCEL: 'Cancel',
  CONTINUE: 'Continue',
  IMPORT: 'Import',
  ADD_CHECKLIST: 'Add Checklist',
  EXPORT: 'Export',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  ADD_EXCEL: 'Add Excel',
  PROCEED: 'Proceed',
  ROLE_TEXT: 'Role',
  PRICING_METHOD_TEXT: 'Pricing Method',
  ROLE_PLACEHOLDER: 'Select role',
  PRICING_METHOD_PLACEHOLDER: 'Select pricing method',
  APPLY: 'Apply',
  RESET: 'Reset',
  CLEAR: 'Clear',
  CLOSE: 'Close',
  CONFIRM: 'Confirm',
  YES: 'Yes',
  NO: 'No',
  SAVE: 'Save',
  SAVE_CHANGES: 'Save changes',
  SAVE_AND_CONTINUE: 'Save and proceed',
  SCHEDULE: 'Schedule',
  UPDATE: 'Update',
  DIRECT: 'Direct',
  REVOKE: 'Yes, revoke',
  DEFAULT_CONFIRMATION_TITLE: 'Unsaved changes will be lost',
  DEFAULT_CONFIRMATION_MESSAGE: 'Are you sure?',
  INACTIVE: 'Inactive',
  ACTION: 'Action',
  SEARCH: 'Search',
  DETAILS: 'Details',
  ANALYTICS: 'Analytics',
  HEATMAP: 'Heatmap',
  BACK: 'Back',
  DISCARD: 'Discard',
  VIEW_SURVEY: 'View survey',
  LOGOUT: 'Logout',
  SETTING: 'Setting',
  RETRY: 'Retry',
  LOGOUT_MESSAGE: 'Are you sure you want to logout?',
  NEXT: 'Next',
  END: 'End of the form',
  SPLITTER: '_',
  EMPTY_LIST_MESSAGE: "You haven't added any _ yet.",
  EMPTY_LIST_DIRECTIVE: 'Click the _ button to add _',
  EMPTY_FILTER_QUERY_MESSAGE: 'No _ found for your query',
  EMPTY_LIST_ERROR_MESSAGE:
    'Sorry we are unable to load all the _.\nPlease click on the retry button',
  EMPTY_CALENDAR_LIST_ERROR_MESSAGE:
    'No data found with selected filters._\nPlease click on the clear filter button',
  OKAY: 'Okay',
  DEFAULT_ERROR_MESSAGE:
    'Sorry we are unable to process your request.\nPlease try and refresh the application',
  COLOUR: 'Colour',
  TAB_BY_URL: 'By URL',
  SIGNAL_R_CONNECTING: 'SignalR is connecting...',
  SIGNAL_R_CONNECTION_SUCCESSFUL: 'SignalR connected successfully',
  SIGNAL_R_CONNECTION_FAILED: 'Unable to connect to SignalR',
  SIGNAL_R_DISCONNECTION_SUCCESSFUL: 'SignalR disconnected',
  SIGNAL_R_DISCONNECTION_FAILED: 'Unable to disconnect from SignalR',
  FILTERS: 'Filters',
  INTERNAL_SERVER_ERROR: 'Internal server error',
  NOT_IMPLEMENTED: 'Not implemented',
  BAD_GATEWAY: 'Bad gateway',
  SERVICE_UNAVAILABLE: 'Service unavailable',
  GATEWAY_TIMEOUT: 'Gateway timeout',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  UNEXPECTED_LOGIN_ERROR:
    'Login failed due to an unexpected error. Please try again or contact support if this continues.',
  UNEXPECTED_SET_PASSWORD_ERROR:
    'Failed to set password due to an unexpected error. Please try again or contact support if this continues.',
  PROFILE: 'Profile',
  ACTIVITIES: 'Activities',
  SUCCESSFUL: 'Successful',
  STARTED: 'Started',
  RESPONDED: 'Responded',
  SENT: 'Sent',
  TODAY: 'Today',
  SELECT_ALL: 'Select all',
  DELETED_SUCCESSFULLY: 'archived successfully',
  CREATED_SUCCESSFULLY: 'created successfully',
  UPDATED_SUCCESSFULLY: 'updated successfully',
  STATUS_UPDATED_SUCCESSFULLY: 'status updated successfully',
  EXPORTED_SUCCESSFULLY: 'exported successfully',
  VIEW: 'View',
  REFRESH: 'Refresh',
  CAPTURE_SIGNATURE_TITLE: 'Capture signature',
  PHOTOS_AND_DOCUMENTS_TITLE: 'Attach picture of weigh ticket',
  UPLOAD: 'Upload',
  CAPTURE: 'Capture',
  NOTIFICATIONS: 'Notifications',
  NO_NOTIFICATIONS: 'No new notifications',
  LOCATION_IS_REQUIRED: 'Location is required',
  OLDER_NOTIFICATIONS: 'Older notifications',
  READ_ONLY_LABEL: '(Read-only)',
  REPEAT_JOB_LABEL: 'Repeat job',
  WATER_COURSES_LABEL: 'Water Courses?',
  NIGHT_OUT_LABEL: 'Night Out?',
  NAME_LABEL: 'Name',
  COLLECTION_SITE_NAME_PLACEHOLDER: 'Enter waste collection site name',
  WASTENAME_LABEL: 'Waste Name',
  WASTENAME_PLACEHOLDER: 'Enter waste name',
  PRODUCT_LABEL: 'Product',
  PRODUCT_PLACEHOLDER: 'Enter product name',
  NITROGEN_QUANTITY_LABEL: 'Nitrogen Percentage',
  POTASSIUM_QUANTITY_LABEL: 'Potassium Percentage',
  SULPHUR_QUANTITY_LABEL: 'Sulphur Percentage',
  ENTER_QUANTITY_PLACEHOLDER: 'Enter percentage quantity',
  PHOSPHORUS_QUANTITY_LABEL: 'Phosphorus Percentage',
  ADDRESS_LABEL: 'Address',
  COLLECTION_SITE_ADDRESS_PLACEHOLDER: 'Enter waste collection site address',
  SITE_LOCATION_LABEL: 'Site Location',
  SITE_LOCATION_PLACEHOLDER: 'Enter site location',
  COLLECTION_SITE_LOCATION_PLACEHOLDER: 'Enter waste collection site location',
  SITE_PICTURE_LABEL: 'Attach Picture of Site Location',
  SILO_PICTURE_LABEL: 'Attach Picture of Silo',
  EMAIL_LABEL: 'Email Address',
  CUSTOMER_CODE_LABEL: 'Customer Code',
  CUSTOMER_CODE_PLACEHOLDER: 'Enter Customer Code',
  DELIVERY_SITE_NAME_PLACEHOLDER: 'Enter AD plant site name',
  DELIVERY_SITE_ADDRESS_PLACEHOLDER: 'Enter AD plant site address',
  WASTE_DELIVERY_SITE_NAME_PLACEHOLDER: 'Enter waste delivery site name',
  WASTE_DELIVERY_SITE_ADDRESS_PLACEHOLDER: 'Enter waste delivery site address',
  DELIVERY_SITE_LOCATION_PLACEHOLDER: 'Enter AD plant site location',
  CONTACT_NUMBER_LABEL: 'Contact Number',
  REGISTRATION_NUMBER_LABEL: 'Registration Number',
  REGISTRATION_NUMBER_PLACEHOLDER: 'Enter registration number',
  CONTACT_NUMBER_PLACEHOLDER: 'Enter contact number',
  SIC_CODE_LABEL: 'SIC Code',
  SIC_CODE_PLACEHOLDER: 'Enter SIC code',
  ID: 'Id',
  NO_VEHICLES_FOUND: 'No vehicles Found',
  SELECT_DATE_TIME: 'Select date and time range.',
  SITE_NAME_HEADER: 'Site Name',
  AD_PLANT_SITE_NAME_HEADER: 'AD Plant Site Name',
  PRODUCT_TYPE_HEADER: 'Product Type',
  SITE_EMAIL_HEADER: 'Site Email',
  ACTION_HEADER: 'Action',
  CUSTOMER_NAME_LABEL: 'Customer Name',
  CUSTOMER_NAME_PLACEHOLDER: 'Enter customer name',
  CONTACT_NAME_LABEL: 'Contact Name',
  CONTACT_NAME_PLACEHOLDER: 'Enter contact name',
  CONTACT_ONE_LABEL: 'Contact Number 1',
  CONTACT_ONE_PLACEHOLDER: 'Enter contact 1',
  CONTACT_TWO_LABEL: 'Contact Number 2',
  CONTACT_TWO_PLACEHOLDER: 'Enter contact 2',
  COLLECTION_SITE: 'Waste collection site',
  ADDRESS_ONE_LABEL: 'Address 1',
  ADDRESS_ONE_PLACEHOLDER: 'Enter address 1',
  ADDRESS_PLACEHOLDER: 'Enter your address',
  POST_CODE_LABEL: 'Postal Code',
  POST_CODE_PLACEHOLDER: 'Enter postal code',
  BILLING_DETAILS_LABEL: 'Billing Details',
  BILLING_DETAILS_PLACEHOLDER: 'Enter billing details',
  PHONE_NUMBER: 'Phone Number',
  EMPLOYEE_NAME_LABEL: 'Employee Name',
  EMPLOYEE_DESIGNATION_LABEL: 'Designation',
  EMPLOYEE_NAME_PLACEHOLDER: 'Enter employee name',
  EMPLOYEE_DESIGNATION_PLACEHOLDER: 'Enter employee designation',
  HOURLY_RATE_LABEL: 'Hourly Rate',
  HOURLY_RATE_PLACEHOLDER: 'Enter hourly rate',
  STATUS_LABEL: 'Status',
  ASSIGNED_EMPLOYEE_LABEL: 'Assigned Employee',
  SCHEDULED_DATE_LABEL: 'Scheduled Date',
  COMPLETION_DATE_LABEL: 'Completion Date',
  STATUS_PLACEHOLDER: 'Select status',
  FARM_INPUT_HEADER: 'Farm Name',
  FARM_INPUT_PLACEHOLDER: 'Enter farm name',
  ADDRESS_INPUT_PLACEHOLDER: 'Enter address',
  CPH_LABEL: 'CPH Number',
  CPH_PLACEHOLDER: 'Enter CPH number',
  FARM_FIELDS_LIST_BTN_LABEL: 'Fields',
  FARM_SILOS_LIST_BTN_LABEL: 'Silo',
  FIELD_REFERENCE_LABEL: 'Field Reference',
  FIELD_REFERENCE_PLACEHOLDER: 'Enter field reference',
  FIELD_SIZE_LABEL: 'Size(ha)',
  FIELD_SIZE_PLACEHOLDER: 'Enter size',
  SELECT_CUSTOMER_PLACEHOLDER: 'Select customer',
  SELECT_FARM_PLACEHOLDER: 'Select farm',
  SELECT_FARM_LABEL: 'Farm',
  SELECT_CROP_LABEL: 'Crop',
  SELECT_CROP_PLACEHOLDER: 'Enter crop',
  PRODUCT_NAME_LABEL: 'Product Name',
  PRODUCT_NAME_PLACEHOLDER: 'Enter product name',
  PRODUCT_CATEGORY_LABEL: 'Product Category',
  PRODUCT_TYPE_LABEL: 'Product Type',
  PRODUCT_TYPE_PLACEHOLDER: 'Enter product type',
  SELECT_COLLECTION_SITE_LABEL: 'Waste Collection Site',
  SELECT_COLLECTION_SITE_PLACEHOLDER: 'Select waste collection site',
  SELECT_DATE_PLACEHOLDER: 'Select date',
  SELECT_DATE: 'Select Date',
  EWC_CODE_LABEL: 'EWC Code',
  EWC_CODE_PLACEHOLDER: 'Enter EWC code',
  NOTES_LABEL: 'Notes',
  NOTES_PLACEHOLDER: 'Enter notes',
  NUTRITION_VALUE_NAME: 'Nutrition Value',
  ANALYSIS_DATE_LABEL: 'Analysis Date',
  DESCRIPTION_LABEL: 'Description',
  SERVICE_NAME_PLACEHOLDER: 'Enter waste collection service name',
  SERVICE_CODE_LABEL: 'Waste Collection Service Code',
  SERVICE_CODE_PLACEHOLDER: 'Enter waste collection service code',
  SELECT_PRODUCT_PLACEHOLDER: 'Select product',
  SELECT_SERVICE_PLACEHOLDER: 'Select waste collection service',
  SELECT_DELIVERY_SITE_LABEL: 'AD Plant Site',
  SELECT_DELIVERY_SITE_PLACEHOLDER: 'Select AD Plant site',
  PRICE_LABEL: 'Price',
  ENTER_PRICE_PLACEHOLDER: 'Enter price',
  EXAMPLE_PLACEHOLDER: 'Reference #',
  TONNAGE_LABEL: 'Tonnage use by area (Tons/Ha)',
  AREA_HECTARE_LABEL: 'Area In Hectare',
  CODE_LABEL: 'Code',
  DELIVERY_SITE_LABEL: 'AD Plant Site',
  SILO_INPUT_PLACEHOLDER: 'Enter silo name',
  TANK_LOCATION_LABEL: 'Tank Location',
  LOCATION_URL_PLACEHOLDER: 'Ex: https://www.google.com/maps',
  ATTACH_SILO_PICTURE: 'Attach Picture of Silo',
  SILO_NAME_TEXT: 'Silo Name',
  TOTAL_VOLUME_HEADER: 'Total Volume(ton)',
  TOTAL_VOLUME_LABEL: 'Total Volume(Ton)',
  VOLUME_LEFT_LABEL: 'Volume Left (tons)',
  VOLUME_LEFT_HEADER: 'Volume Left (tons)',
  CAPACITY_AVAILABLE_HEADER: 'Capacity Available (tons)',
  EMPLOYEE_LABEL: 'Employee',
  SELECT_EMPLOYEE_PLACEHOLDER: 'Select an employee',
  WORK_LABEL: 'Work',
  TYPE_LABEL: 'Type',
  HALF_DAY_LABEL: 'Half-Day',
  FULL_DAY_LABEL: 'Full-Day',
  ADD_BREAK_TIME_LABEL: 'Add Break Time',
  SELECT_VEHICLE_LABEL: 'Vehicle',
  SELECT_VEHICLE_PLACEHOLDER: 'Select vehicle',
  SELECT_TRAILER_LABEL: 'Trailer',
  SELECT_TRAILER_PLACEHOLDER: 'Select trailer',
  SELECT_TYPE_TEXT: 'Select Type',
  DATE_LABEL: 'Date',
  START_TIME_LABEL: 'Start Time',
  FINISH_TIME_LABEL: 'Finish Time',
  TOTAL_BREAK_LABEL: 'Total Break (hrs)',
  TOTAL_HOURS_LABEL: 'Total Hours',
  NIGHT_OUT_HEADER: 'Night Out',
  SEARCH_BY_ID_PLACEHOLDER: 'Search by ID',
  SILO_SEARCH_PLACEHOLDER: 'Search by silo name',
  SITE_SEARCH_PLACEHOLDER: 'Search by AD plant site name',
  WASTE_DELIVERY_SITE_SEARCH_PLACEHOLDER: 'Search by site name',
  SERVICE_SEARCH_PLACEHOLDER: 'Search by waste collection service name',
  COLLECTION_SITE_SEARCH_PLACEHOLDER: 'Search by site name',
  FARM_SEARCH_PLACEHOLDER: 'Search by farm name',
  FIELD_SEARCH_PLACEHOLDER: 'Search by field reference',
  VEHICLE_SEARCH_PLACEHOLDER: 'Search by vehicle name',
  TRAILER_SEARCH_PLACEHOLDER: 'Search by trailer name',
  PRODUCT_SEARCH_PLACEHOLDER: 'Search by product name',
  CUSTOMER_NAME_SEARCH_PLACEHOLDER: 'Search by customer name',
  EMPLOYEE_NAME_SEARCH_PLACEHOLDER: 'Search by employee name',
  JOBS_HEADER: 'Jobs',
  VEHICLE_DETAILS_HEADER: 'Vehicle Details',
  HOLIDAY_LABEL: 'Type',
  TRAILER_NAME_LABEL: 'Trailer Name',
  TRAILER_NAME_PLACEHOLDER: 'Enter trailer name',
  MAKE_LABEL: 'Make',
  MAKE_PLACEHOLDER: 'Enter company name',
  MODEL_LABEL: 'Model',
  MODEL_PLACEHOLDER: 'Enter model name',
  DAILY_COST_LABEL: 'Daily Cost',
  DAILY_COST_PLACEHOLDER: 'Enter daily cost',
  VEHICLE_NAME_LABEL: 'Vehicle Name',
  VEHICLE_NAME_PLACEHOLDER: 'Enter vehicle name',
  VRM_TEXT_PLACEHOLDER: 'Enter VRM',
  MAKE_INPUT_PLACEHOLDER: 'Enter make',
  MODEL_INPUT_PLACEHOLDER: 'Enter model',
  USUAL_TRAILER_LABEL: 'Usual Trailer',
  USUAL_TRAILER_PLACEHOLDER: 'Select usual trailer',
  TITLE_TEXT: 'Title',
  VEHICLE_ID_HEADER: 'Vehicle Id',
  ASSIGNED_TO_TEXT: 'Assigned To',
  PURCHASE_ORDER: 'Purchase Order',
  SELECT_DROP_LOCATION_LABEL: 'Drop Location',
  SELECT_DROP_LOCATION_PLACEHOLDER: 'Select drop location',
  TEXT_AREA_PLACEHOLDER: 'Enter description.',
  AD_SITES_LABEL: 'AD Plant Site',
  WD_SITES_LABEL: 'Waste delivery site',
  DELIVERY_SITES_LABEL: 'Delivery Site',
  PRE_ASSESSMENT_TIME: 'Pre-assessment time',
  SPREADING_TIME: 'Spreading time',
  WIND_SPEED: 'Wind speed',
  CLOUD_CONDITIONS: 'Cloud conditions',
  WIND_DIRECTION: 'Wind direction',
  TEMPERATURE: 'Temperature',
  FIELD_CONDITIONS: 'Field conditions',
  ACTUAL_TONNAGE_USE: 'Actual tons spread on the field',
  MATERIAL_RUN_OFF: 'Material run off',
  ODOUR_NUISANCE: 'Odour nuisance',
  WATER_POLLUTION: 'Water pollution',
  VALID_QUANTITY_ERROR: 'Please enter a valid quantity.',
  NAV_LOGO_TEXT: 'Awsm logo',
  MARK_AS_READY_TO_INVOICE: 'Ready to Invoice',
  MARK_AS_INVOICE: 'Invoiced',

  AD_SITES_PLACEHOLDER: 'Select AD plant site',
  SELECT_PICKUP_LOCATION: 'Select pick up location',
  FIELD_TEXT: 'Fields',
  SELECT_FIELD: 'Select fields',
  SPREADING_METHOD_LABEL: 'Spreading method',
  SPREADING_METHOD_PLACEHOLDER: 'Enter method',
  SELECT_WEIGH_NUMBER_PLACEHOLDER: 'Select weigh number',
  NO_PHOTOS_AND_DOCUMENTS: 'No photos or documents uploaded',

  WD_SITES_PLACEHOLDER: 'Select waste delivery site',
  SELECT_DELIVERY_TYPE: 'Select delivery site type',

  // Import
  SAMPLE_FILE_TITLE: 'Sample file',
  SAMPLE_FILE_MESSAGE: 'You can download the sample file provided.',
  IMPORT_IN_PROGRESS: 'Importing',
  IMPORT_MESSAGE: 'Drag and drop or click to upload XLSX file',
  IMPORT_SAMPLE_FILE_NAME: 'bulk_import_sample',
  IMPORT_COLLECTION_FILE_NAME: 'collection_import_sample',
  IMPORT_WASTE_DELIVERY_FILE_NAME: 'waste_delivery_import_sample',
  IMPORT_CUSTOMER_FILE_NAME: 'customer_import_sample',
  IMPORT_TRAILER_FILE_NAME: 'trailer_import_sample',
  IMPORT_FARMS_FILE_NAME: 'farm_import_sample',
  IMPORT_PRODUCTS_FILE_NAME: 'product_import_sample',
  IMPORT_VEHICLE_FILE_NAME: 'vehicle_import_sample',
  IMPORT_SUCCESSFULLY: 'Imported sucessfully',
  IMPORT_FAILED: 'Failed to import',
  IMPORT_IGNORED: 'Ignored to import',
  PRODUCT_ERROR_FILE: 'Product_error',
  COLLECTION_ERROR_FILE: 'waste_collection_site_errors',
  WASTE_DELIVERY_ERROR_FILE: 'waste_delivery_site_errors',
  CUSTOMER_ERROR_FILE: 'Customer_error',
  FARMS_ERROR_FILE: 'Farm_error',
  TRAILER_ERROR_FILE: 'Trailer_error',
  VEHICLE_ERROR_FILE: 'Vehicle_error',

  // Login
  DASHBOARD_TITLE: 'Dashboard',
  LOGIN_TITLE: 'Sign in',
  LOGIN_TITLE_DESCRIPTION: 'Log in to your account',
  FORGOT_PASSWORD_TITLE: 'Forgot Password?',
  FORGOT_PASSWORD_TITLE_DESCRIPTION: 'Enter your email to reset your password',
  RESET_PASSWORD_TITLE: 'Reset Password',
  RESET_PASSWORD_TITLE_DESCRIPTION: 'Enter and update your password',
  SET_PASSWORD_TITLE: 'Set Password',
  SET_PASSWORD_TITLE_DESCRIPTION: 'Set your password',
  PASSWORD_SET_SUCCESS_MESSAGE: 'Please login with your new password.',
  EMAIL_INPUT_LABEL: 'Email address',
  EMAIL_INPUTS_LABEL: 'Enter email addresses',
  EMAIL_INPUT_PLACEHOLDER: 'name@email.com',
  USERNAME_INPUT_LABEL: 'Username',
  PASSWORD_INPUT_LABEL: 'Password',
  PASSWORD_INPUT_PLACEHOLDER: 'Enter password',
  NEW_PASSWORD_INPUT_LABEL: 'New password',
  NEW_PASSWORD_INPUT_PLACEHOLDER: 'Enter new password',
  CONFIRM_PASSWORD_INPUT_LABEL: 'Confirm password',
  CONFIRM_PASSWORD_INPUT_PLACEHOLDER: 'Enter confirm new password',
  LOGIN_BUTTON_LABEL: 'Login',
  SUBMIT: 'Submit',
  FORGOT_PASSWORD: 'Forgot password?',
  BACK_TO_LOGIN: 'Back to login',
  REMEMBER_USER: 'Keep me logged in',
  CHANGE_PASSWORD: 'Change password',
  ASSIGN_FIELDS_LABEL: 'Fields',
  ASSIGN_SILOS_LABEL: 'Silos',
  SEARCH_FIELDS_PLACEHOLDER: 'Search fields',

  //job
  CREATE: 'Create',
  ADD_JOB: 'Add job',
  ADD_CUSTOMER: 'Add Customer',
  ADD_TRAILER: 'Add Trailer',
  ADD_VEHICLE: 'Add Vehicle',
  ADD_FIELD: 'Add Field',
  ADD_FARM: 'Add Farm',
  ADD_SERVICE: 'Add waste collection service',
  ADD_DELIVERY_SITE: 'Add AD Plant Site',
  ADD_WASTE_DELIVERY_SITE: 'Add Waste Delivery Site',
  ADD_COLLECTION_SITE: 'Add Site',
  ADD_PRODUCT: 'Add Product',
  ADD_SILO: 'Add Silo',
  ADD_TIMESHEET: 'Add Timesheet',
  ADD_TIME: '+ Add Time',
  ADD_EMPLOYEE: 'Add Employee',
  UPDATE_JOB: 'Update Job',
  VIEW_CHECKLIST: 'View Checklist',

  // Validations
  POSITIVE_FORMAT_RULE: 'Value must be positive.',
  CONTACT_VALIDATION_FORMAT_RULE: 'Invalid format.',
  PRICE_REQUIRED_RULE: 'Price is required.',

  // Errors
  COMPONENT_ERROR: 'Client Error',
  NETWORK_ERROR: 'Server Error',
  NETWORK_ERROR_UNKNOWN: 'Service currently unavailable. Please try again later.',
  CORRUPT_IMPORT_ERROR: 'Error: Invalid or corrupt file',
  FILE_PARSING_FAILED_MESSAGE: 'Failed to parse file:',
  ERROR_LABEL: 'Error',
  ERROR_CLASSES: 'Occurred at element with classes:',
  ERROR_PROPS: 'Props: ',
  ERROR_COMPONENT: 'Component: ',
  ERROR_IGNORES: ['canceled'],

  // List
  NO_DATA_TITLE: 'No Data',
  NO_DATA_MESSAGE: 'Click on the add button on the top right to create a',
  NO_DATA_INSPECTION_MESSAGE: 'No inspection available',
  NO_DATA_FUEL_INSPECTION_MESSAGE: 'No fuel entry available',
  NO_DATA_AD_BLUE_MESSAGE: 'No AdBlue entry available',
  NO_DATA_HISTORY_MESSAGE: 'No history available for this item',
  VIEW_ORIGINAL: 'View original',
  HAULAGE_ID: 'Id',
  HAULAGE_CUSTOMER: 'Customer',
  HAULAGE_SERVICES: 'Service',
  HAULAGE_PRODUCT_TYPE: 'Product Type',
  HAULAGE_PICKUP_LOCATION: 'Pickup Location',
  HAULAGE_DESTINATION: 'Destination',
  HAULAGE_REQUEST_DATES: 'Request Dates',
  HAULAGE_REQUEST_DATE: 'Request Date',
  HAULAGE_SCHEDULED_DATE: 'Scheduled Date',
  HAULAGE_EMPLOYEE: 'Employee',
  HAULAGE_VEHICLE: 'Vehicle',
  HAULAGE_STATUS: 'Status',
  ADD_ATTACHMENT_TEXT: 'Add attachment',

  DIGESTATE_ID: 'Id',
  DIGESTATE_FARM: 'Farm',
  DIGESTATE_PICKUP_LOCATION: 'Pickup Location',
  DIGESTATE_DESTINATION: 'Destination',
  DIGESTATE_SCHEDULED_DATE: 'Scheduled Date',
  DIGESTATE_EMPLOYEE: 'Employee',
  DIGESTATE_VEHICLE: 'Vehicle',
  DIGESTATE_REPEATABLE: 'Repeatable',
  DIGESTATE_STATUS: 'Status',
  DIGESTATE_COMPLETION_DATE: 'Completion date',
  DIGESTATE_ASSIGNED_EMPLOYEE: 'Assigned Employee',

  SPREADING_ID: 'Id',
  SPREADING_SPREADING_METHOD: 'Spreading Method',
  SPREADING_FARM: 'Farm',
  SPREADING_PICKUP: 'Pickup',
  SPREADING_DESTINATION: 'Destination',
  SPREADING_TONS: 'Tons',
  SPREADING_AREA: 'Area(ha)',
  SPREADING_SCHEDULED_DATE: 'Schedule Date',
  SPREADING_COMPLETED_DATE: 'Completed On',
  SPREADING_EMPLOYEE: 'Employee',
  SPREADING_VEHICLES: 'Vehicle',
  SPREADING_REPEATABLE: 'Repeatable',
  SPREADING_STATUS: 'Status',

  //trailer list strings
  TRAILER_ID_TEXT: 'Trailer Id',
  TRAILER_NAME_TEXT: 'Trailer Name',
  VRM_TEXT: 'VRM',
  MAKE_AND_MODEL_TEXT: 'Make and Model',
  DAILY_COST_NUMBERS: 'Daily Cost',
  Action: 'Action',

  //field list strings
  FIELD_ID_TEXT: 'Id',
  FIELD_REFERENCE_TEXT: 'Field Reference',
  FIELD_SIZE_NUMBERS: 'Area(Ha)',
  FARM_NAME_TEXT: 'Farm',
  LOCATION_TEXT: 'Location',
  CROP_TEXT: 'Crop',
  WATER_COURSES_TEXT: 'Water Courses',
  FIELD_ACTION: 'Action',

  //farms list strings
  FARM_ID_TEXT: 'Id',
  FARM_ADDRESS_TEXT: 'Address',
  FARM_CONTACT_NUMBER: 'Contact Number',
  FARM_EMAIL_ADDRESS_TEXT: 'Email Address',
  FARM_FIELDS_TEXT: 'Fields',
  FARM_SILO_TEXT: 'Silos',
  FARM_ACTION: 'Action',
  FARM_NO_RECORD_FOUND: 'No record found',
  FARM_ASSIGNED_SUCCESSFULLY: 'Assigned successfully',
  FARM_IGNORE_TO_ASSIGN: 'Ignored to assign',

  SERVICE: 'Service',
  WASTE_COLLECTION_SERVICE: 'Waste Collection Service',
  CUSTOMER: 'Customer',
  JOB_NUMBER: 'Job Number',
  PRODUCT_TYPE: 'Product type',
  REQUEST_DATE: 'Request date',
  SCHEDULED_DATE: 'Schedule Date',
  COMPLETED_DATE: 'Completed On',
  PICKUP_LOCATION: 'Pickup Location',
  PICKUP_LOCATION_PLACEHOLDER: 'Pickup location',
  DESTINATION: 'Destination',
  PRICE_QUOTED: 'Price Quoted',
  PRICE: 'Price',
  TOTAL_PRICE: 'Total Amount',
  NOTES: 'Notes',
  EMPLOYEE: 'Employee',
  VEHICLE: 'Vehicle',
  TRAILER: 'Trailer',
  FIELD: 'Field',
  COLLECTION_TIME: 'Collection time',
  WEIGH_TICKET_NUMBER: 'Weigh ticket number',
  QUANTITY: 'Quantity',
  DESCRIPTION: 'Description',
  IS_OPERATOR_PRESENT_TEXT: 'Is Operator present?',
  TANK_CLEANED_LABEL: 'Is tank cleaned?',
  SEND_EMAIL_ON_JOB_COMPLETION: 'Send Email on Job Completion',
  TANK_DISINFECTED_LABEL: 'Is tank disinfected?',
  PICKUP_LOCATION_DETAILS_LABEL: 'Pickup location details',
  DROP_LOCATION_DETAILS_LABEL: 'Drop location details',
  POUND_TEXT: '£',
  DELETE_JOB_TEXT: 'Archive Job',
  EDIT_JOB_TEXT: 'Edit job',
  CLOSED_TEXT: 'Closed',
  TOTAL_TON_LABEL: 'Total Tons:',
  TONS_PER_HECTARE_TEXT: '(Tons/Ha)',
  HECTARE_TEXT: '(Ha)',
  TONS_TEXT: 'Tons',
  HIDE_TEXT: 'Hide',
  SHOW_TEXT: 'Show',
  ENTER_QUANTITY: 'Enter quantity',
  ODOMETER_START: 'Odometer Start',
  ODOMETER_FINISH: 'Odometer Finish',
  START_JOB: 'Start Job',
  COMPLETE_JOB: 'Complete Job',
  READY_TO_INVOICE: 'Ready To Invoice',
  INVOICE: 'Invoice',
  RETRY_MESSAGE: "Haven't received an email yet?",
  PASSWORD_RESET_SUCCESS: 'Password reset successful',
  PASSWORD_SET_SUCCESS: 'Password set successfully.',
  PASSWORD_NOT_SET_ERROR: 'Password not set',
  NOT_ASSIGNED: '-',
  JOB_NOT_FOUND: 'Job not found',
  JOB_DELETED_TEXT: 'This job has been deleted and cannot be viewed.',
  PASSWORD_REQUIREMENT_TITLE: 'Password should contain',
  FUEL_TYPE: 'Type',
  FUEL_VOLUME: 'Volume',
  FUEL_UNIT: 'Fuel Unit',
  USED_FUEL_CARDS: 'Used Cards',
  COMMENTS: 'Comments',
  COMMENT: 'Comment',
  CHECKLIST: 'Checklist',
  YES_NO: 'YES / NO',
  NO_CHECKLIST: 'No checklist available',
  PRICE_UNIT: 'Price Unit'
}
